<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Menu Item Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="fullName"
                  v-model="formValues.menuItemName"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >URL</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="fullName"
                  v-model="formValues.url"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Icon</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="fullName"
                  v-model="formValues.icon"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Menu code</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="fullName"
                  v-model="formValues.menuItemCode"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <!-- <button
            @click="$emit('close')"
            class="float-left shadow focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded"
            type="button"
            >Cancel</button>-->
            <button
                class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="button"
                @click="submit()"
            >
              {{ formValues.editMode ? "Update Menu Item" : "Add Menu Item" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>


<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {min_value, required} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});
export default {
  props: {
    menuItem: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        menuItemName: "",
        url: "",
        icon: "",
        menuItemCode: "",
        editMode: false,
      },
    };
  },
  async beforeMount() {
  },
  created() {
    if (this.menuItem != null) {
      this.formValues = this.menuItem;
      this.formValues.editMode = true;
    }
  },
  methods: {
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateMenuItem", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>